(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["number-column"] && !Shopify.designMode) return;
  try {
    
  var flkty = new Flickity( '.nc-carousel', {
    cellAlign: 'left',
    contain: true,
    autoPlay: true
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-image-text-2-col"] && !Shopify.designMode) return;
  try {
    
  consol.log("this is the section")

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-image-text-2-col"] && !Shopify.designMode) return;
  try {
    
  consol.log("this is the section")

  } catch(e) { console.error(e); }
})();
})();
